import { render, staticRenderFns } from "./DataReview.vue?vue&type=template&id=e1f6a7f4"
import script from "./DataReview.vue?vue&type=script&lang=js"
export * from "./DataReview.vue?vue&type=script&lang=js"
import style0 from "./DataReview.vue?vue&type=style&index=0&id=e1f6a7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports